"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var GiftSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M7.5,5 C6.67157288,5 6,4.32842712 6,3.5 C6,2.67157288 6.67157288,2 7.5,2 C7.84387522,2 8.51809129,2.03686814 9.1345208,2.96326727 C9.23817592,3.11904502 9.36000231,3.36063017 9.5,3.68802271 C9.63999769,3.36063017 9.76182408,3.11904502 9.8654792,2.96326727 C10.4819087,2.03686814 11.1561248,2 11.5,2 C12.3284271,2 13,2.67157288 13,3.5 C13,4.32842712 12.3284271,5 11.5,5 L15,5 C15.5522847,5 16,5.44771525 16,6 L16,9 C15.7015232,9 15.3681898,9 15,9 L15,14 C15,14.5522847 14.5522847,15 14,15 L5,15 C4.44771525,15 4,14.5522847 4,14 L4,9 C3.63181017,9 3.29847683,9 3,9 L3,6 C3,5.44771525 3.44771525,5 4,5 L7.5,5 Z M4,6 L4,8 L9,8 L9,6 L4,6 Z M10,6 L10,8 L15,8 L15,6 L10,6 Z M5,9 L5,14 L9,14 L9,9 L5,9 Z M10,9 L10,14 L14,14 L14,9 L10,9 Z M11.5,4.25 C11.9142136,4.25 12.25,3.91421356 12.25,3.5 C12.25,3.08578644 11.9142136,2.75 11.5,2.75 C11.0934971,2.75 10.8332283,2.86274736 10.4898806,3.37874635 C10.389104,3.53019818 10.2498637,3.82405206 10.0792635,4.25 L11.5,4.25 Z M7.5,4.25 L8.92073649,4.25 C8.75013627,3.82405206 8.61089601,3.53019818 8.51011939,3.37874635 C8.16677169,2.86274736 7.90650294,2.75 7.5,2.75 C7.08578644,2.75 6.75,3.08578644 6.75,3.5 C6.75,3.91421356 7.08578644,4.25 7.5,4.25 Z" })));
};
GiftSmall.displayName = 'GiftSmall';
exports.default = GiftSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=GiftSmall.js.map